import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  IconButton,
  Tooltip,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import DownloadIcon from "../../assets/icons/download-icon.svg";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "95%",
  justifyContent: "flex-start",
  width: "100%",
});

function AdmDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Resumo");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);

  const handleChange = (event) => {
    app.field("Tipo_adm").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };

  const exportAllTables = async () => {
    const ids = ["PaVepGA", "SNjwJ", "dxSwqpn"];
    console.log("Exportar clicado. IDs a exportar:", ids);
    setLoadingExcel(true);
    for (const id of ids) {
      try {
        const vis = await app.visualization.get(id);
        const link = await vis.table.exportData({ format: "OOXML", state: "A" });
        const xlsLink = `https://${process.env.REACT_APP_HOST + process.env.REACT_APP_PREFIX}${link.substring(link.indexOf("tempcontent"))}`;
        window.open(xlsLink);
      } catch (e) {
        // erro silencioso para não travar exportação dos outros
      }
    }
    setLoadingExcel(false);
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_adm")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      console.log(distributors)
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app adm">
      <div className="appContent">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          <Tooltip title="Exportar todas as tabelas para Excel">
            <span>
              <IconButton type="button" onClick={exportAllTables} disabled={loadingExcel}>
                <span style={{ marginRight: 8 }}>Exportar</span>
                {!loadingExcel ? (
                  <img src={DownloadIcon} alt="icon-download" />
                ) : (
                  <span style={{ fontSize: 12 }}>Exportando...</span>
                )}
              </IconButton>
            </span>
          </Tooltip>
        </div>
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="Resumo"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Resumo"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Resumo"
            />

            <FormControlLabel
              value="Visão Detalhada"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Visão Detalhada"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              {selectedValue === "Resumo" ? (
                <>

                  <div className="adm-cards">

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Qtd DQBs Elegíveis",
                      }}
                      style={{
                        width: "15%",
                        height: "100%",
                        justifyContent: "space-around"
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="PaVepGA"
                        reference={{ id: "PaVepGA" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Premiação",
                      }}
                      style={{
                        width: "15%",
                        height: "100%",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="SNjwJ"
                        reference={{ id: "SNjwJ" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                  </div>

                  <Card
                    app={app}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId={["dxSwqpn", "PaVepGA", "SNjwJ"]}
                    exportTablesId={true}
                  >
                    <NativeObject
                      app={app}
                      key="dxSwqpn"
                      reference={{ id: "dxSwqpn" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                </>
              ) : null}

              {selectedValue === "Visão Detalhada" ? (
                <>

                  <Card
                    app={app}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="dxSwqpn"
                  >
                    <NativeObject
                      app={app}
                      key="dxSwqpn"
                      reference={{ id: "dxSwqpn" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                </>
              ) : null}
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

AdmDesktop.defaultProps = {
  app: null,
  config: {},
};

AdmDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default AdmDesktop;
